import { Injectable, inject } from '@angular/core';
import { UserLoginService } from 'src/app/login/userlogin.service';

@Injectable({
  providedIn: 'root'
})
export class SchoolRoutingUtilityService {
  private userLoginService = inject(UserLoginService);

  public get masterPathName(): string {
    const user = this.userLoginService.User();
    if (!user || !user.roleId) return 'school';
    
    // Parse roleId from comma-separated string to number array
    const roleIds = user.roleId.split(',').map((r: string) => Number(r.trim()));

    if (roleIds.includes(25)) return 'school-owner';
    if (roleIds.includes(5)) return 'school-admin';
    if (roleIds.includes(6)) return 'school-parent';
    if (roleIds.includes(17)) return 'school-teacher';
    if (roleIds.includes(18)) return 'school-non-teaching';
    if (roleIds.includes(16)) return 'school-student';
    if (roleIds.includes(19)) return 'school-driver';
    if (roleIds.includes(33)) return 'school-principal';
    
    return 'school';
  }
}
